import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-5" }
const _hoisted_2 = { class: "grid gap-3 sm:grid-cols-1" }
const _hoisted_3 = { class: "grid gap-3 sm:grid-cols-2" }
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "grid gap-3 sm:grid-cols-2" }

import { InputRow, Select, SectionHeader, MultiCombobox, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import {
        optionsCompanyServices,
        optionsYesNo,
        optionsFrequency,
        optionsWeekdays,
    } from '@/utils/form';
    import type { SelectOption, User } from '@/types';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyServiceForm',
  props: {
    form: {},
    keepersEmployees: {},
    clients: { default: () => [] },
    kubeOptions: {}
  },
  setup(__props: any) {

    const { hasAnyPermission } = usePermissions();

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.services')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "services",
        label: "companies.form.choose_services"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MultiCombobox), {
            modelValue: _ctx.form.services,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.services) = $event)),
            options: _unref(optionsCompanyServices),
            translate: true,
            placeholder: _ctx.$t('companies.form.choose_services')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"])
    ]),
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.general_settings')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "num_of_vouchers",
        label: "companies.form.system_details.num_of_vouchers"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "num_of_vouchers",
            modelValue: _ctx.form.num_of_vouchers,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.num_of_vouchers) = $event)),
            autocomplete: "num_of_vouchers",
            placeholder: _ctx.$t('companies.form.system_details.num_of_vouchers'),
            type: "number"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "has_payments",
        label: "companies.form.system_details.has_payments"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.has_payments,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.has_payments) = $event)),
            options: _unref(optionsYesNo),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(InputRow), {
          form: _ctx.form,
          name: "fixed_price",
          label: "companies.form.system_details.fixed_price",
          class: "flex-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "fixed_price",
              modelValue: _ctx.form.fixed_price,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.fixed_price) = $event)),
              autocomplete: "fixed_price",
              placeholder: _ctx.$t('companies.form.system_details.fixed_price'),
              type: "number"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_unref(InputRow), {
          form: _ctx.form,
          name: "price_frequency",
          label: "companies.form.system_details.price_frequency"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Select), {
              modelValue: _ctx.form.price_frequency,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.price_frequency) = $event)),
              options: [
                            { value: 'hourly', label: 'companies.price_frequency_options.hourly' },
                            {
                                value: 'monthly',
                                label: 'companies.price_frequency_options.monthly',
                            },
                        ],
              translate: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "voucher_limit",
        label: "companies.form.system_details.voucher_limit"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "voucher_limit",
            modelValue: _ctx.form.voucher_limit,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.voucher_limit) = $event)),
            autocomplete: "voucher_limit",
            placeholder: _ctx.$t('companies.form.system_details.voucher_limit'),
            type: "number"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "report_deadline",
        label: "companies.form.system_details.report_deadline"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "report_deadline",
            modelValue: _ctx.form.report_deadline,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.report_deadline) = $event)),
            autocomplete: "report_deadline",
            placeholder: _ctx.$t('companies.form.system_details.report_deadline'),
            type: "number"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "salary_deadline",
        label: "companies.form.system_details.salary_deadline"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "salary_deadline",
            modelValue: _ctx.form.salary_deadline,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.salary_deadline) = $event)),
            autocomplete: "salary_deadline",
            placeholder: _ctx.$t('companies.form.system_details.salary_deadline'),
            type: "number"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "vat_frequency",
        label: "companies.form.system_details.vat_frequency"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.vat_frequency,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.vat_frequency) = $event)),
            options: _unref(optionsFrequency),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "update_frequency",
        label: "companies.form.system_details.update_frequency"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.update_frequency,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.update_frequency) = $event)),
            options: _unref(optionsFrequency).filter((option) => option.value !== 'n/a'),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "has_e_income",
        label: "companies.form.system_details.has_e_income"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.has_e_income,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.has_e_income) = $event)),
            options: _unref(optionsYesNo),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "day_frequency",
        label: "companies.form.system_details.day_frequency"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MultiCombobox), {
            modelValue: _ctx.form.day_frequency,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.day_frequency) = $event)),
            options: _unref(optionsWeekdays),
            translate: true,
            placeholder: _ctx.$t('companies.form.system_details.day_frequency')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "salary_system",
        label: "companies.form.system_details.salary_system"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "salary_system",
            modelValue: _ctx.form.salary_system,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.salary_system) = $event)),
            autocomplete: "salary_system",
            placeholder: _ctx.$t('companies.form.system_details.salary_system')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      (
                    _unref(hasAnyPermission)([
                        _unref(Permission).SALARY_PAYSLIPS_VIEW,
                        _unref(Permission).SALARY_PAYROLLS_VIEW,
                    ])
                )
        ? (_openBlock(), _createBlock(_unref(InputRow), {
            key: 0,
            form: _ctx.form,
            name: "salary_two_step_approval",
            label: "companies.two_step_verification"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Select), {
                modelValue: _ctx.form.salary_two_step_approval,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.salary_two_step_approval) = $event)),
                options: _unref(optionsYesNo),
                translate: true
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }, 8, ["form"]))
        : _createCommentVNode("", true),
      (_ctx.form.salary_two_step_approval)
        ? (_openBlock(), _createBlock(_unref(InputRow), {
            key: 1,
            form: _ctx.form,
            name: "approver_1",
            label: "companies.approver_1"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Combobox), {
                modelValue: _ctx.form.approver_1,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.approver_1) = $event)),
                options: _ctx.clients,
                placeholder: _ctx.$t('companies.approver_1'),
                loading: !_ctx.keepersEmployees.length,
                "label-by": "name",
                "value-by": "id"
              }, null, 8, ["modelValue", "options", "placeholder", "loading"])
            ]),
            _: 1
          }, 8, ["form"]))
        : _createCommentVNode("", true),
      (_ctx.form.salary_two_step_approval)
        ? (_openBlock(), _createBlock(_unref(InputRow), {
            key: 2,
            form: _ctx.form,
            name: "approver_2",
            label: "companies.approver_2"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Combobox), {
                modelValue: _ctx.form.approver_2,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.approver_2) = $event)),
                options: _ctx.clients,
                placeholder: _ctx.$t('companies.approver_2'),
                loading: !_ctx.keepersEmployees.length,
                "label-by": "name",
                "value-by": "id"
              }, null, 8, ["modelValue", "options", "placeholder", "loading"])
            ]),
            _: 1
          }, 8, ["form"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SectionHeader), null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('companies.kube_settings')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "has_kube",
        label: "companies.form.system_details.has_kube"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.has_kube,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.has_kube) = $event)),
            options: _unref(optionsYesNo),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "kube_id",
        label: "companies.form.system_details.kube_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "kube_id",
            modelValue: _ctx.form.kube_id,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.kube_id) = $event)),
            autocomplete: "kube_id",
            placeholder: _ctx.$t('companies.form.system_details.kube_id'),
            disabled: ""
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "to_keepers_kube",
        label: "companies.form.system_details.to_keepers_kube"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.to_keepers_kube,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.to_keepers_kube) = $event)),
            options: _unref(optionsYesNo),
            translate: true
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "kube_data_field_id",
        label: "companies.form.system_details.kube_data_field_id"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.kube_data_field_id,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.kube_data_field_id) = $event)),
            options: _ctx.kubeOptions,
            "value-by": "id",
            "label-by": "name"
          }, null, 8, ["modelValue", "options"])
        ]),
        _: 1
      }, 8, ["form"])
    ])
  ]))
}
}

})